/*

    Copyright (c) Manuel Stofer 2013 - today, PinchZoom.js

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
    THE SOFTWARE.

*/
// import $ from 'jquery';
// import ActionTypes from "../misc/actionTypes";

import pinchScroll from "./pinchScroll";
import ActionTypes from "../misc/actionTypes";
import {GROHE_CONFIG} from "../bvcomponents/look/grohe/groheConfig";
import {IS_LOOK_JOURNEY, IS_PRODUCT_JOURNEY} from "../config";
import store from "../store";
import {setCanvasScale} from "../actions/actionFunctions";

// polyfills
if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

if (typeof Array.from != 'function') {
  Array.from = function (object) {
    return [].slice.call(object);
  };
}

// utils
var buildElement = function(str) {
  // empty string as title argument required by IE and Edge
  var tmp = document.implementation.createHTMLDocument('');
  tmp.body.innerHTML = str;
  return Array.from(tmp.body.children)[0];
};

var triggerEvent = function(el, name) {
  var event = document.createEvent('HTMLEvents');
  event.initEvent(name, true, false);
  el.dispatchEvent(event);
};

const sanitizeValue = (newValue) => {
  return isNaN(newValue) ? 0 : newValue
}

var definePinchZoom = function () {

  /**
   * Pinch zoom
   * @version 2.0.0
   * @author Manuel Stofer <mst@rtp.ch>
   * @param el
   * @param options
   * @constructor
   */
  var PinchZoom = function (el, options) {
      this.el = el;
      this.elText = document.querySelector('.canvas-text');
      this.zoomFactor = 1;
      this.lastScale = 1;
      this.offset = {
        x: 0,
        y: 0
      };
      this.mousePos = {
        x: 0,
        y: 0
      };
      this.coImage = null;
      this.containerScrolled = false;
      this.mouseDown = false;
      this.timerId = null;
      this.timerId = null;
      this.options = Object.assign({}, this.defaults, options);
      this.setupMarkup();
      this.bindEvents();
      if (this.options.canUseUpdate) {
        this.update();
      }
      // default enable.
      this.enable();

    },
    sum = function (a, b) {
      return a + b;
    },
    isCloseTo = function (value, expected) {
      return value > expected - 0.01 && value < expected + 0.01;
    },
    interaction = null;

  PinchZoom.prototype = {

    defaults: {
      tapZoomFactor: 1.75,
      zoomOutFactor: 1.3,
      animationDuration: 500,
      maxZoom: 1.75,
      minZoom: 1,
      lockDragAxis: false,
      use2d: true,
      dragPixelsBeforeClick: 6,
      zoomStartEventName: 'pz_zoomstart',
      zoomEndEventName: 'pz_zoomend',
      dragStartEventName: 'pz_dragstart',
      dragEndEventName: 'pz_dragend',
      doubleTapEventName: 'pz_doubletap',
      canUseUpdate: true
    },

    /**
     * Event handler for 'dragstart'
     * @param event
     * @param isMobile {boolean}
     */
    handleDragStart: function (event, isMobile = true) {
      triggerEvent(this.el, this.options.dragStartEventName);
      this.stopAnimation();
      this.lastDragPosition = false;
      this.hasInteraction = true;
      isMobile ? this.handleDrag(event) : this.handleMove(event);
    },

    /**
     * Event handler for 'drag'
     * @param event
     */
    handleDrag: function (event) {
      if (this.zoomFactor > 1.0) {
        var touch = this.getTouches(event)[0];
        this.drag(touch, this.lastDragPosition);
        this.offset = this.sanitizeOffset(this.offset);
        this.lastDragPosition = touch;
      }
    },
    /**
     * Event handler for 'drag'
     * @param event
     */
    handleMove: function (event) {
      let mousePos = this.getTouches({
        touches: [{
          pageX: event.pageX,
          pageY: event.pageY,
        }]
      })[0];
      // console.log("mousePos", mousePos);
      this.drag(mousePos, this.lastDragPosition);
      this.offset = this.sanitizeOffset(this.offset);
      this.lastDragPosition = mousePos;
    },

    handleDragEnd: function () {
      triggerEvent(this.el, this.options.dragEndEventName);
      this.end();
    },

    /**
     * Event handler for 'zoomstart'
     * @param event
     */
    handleZoomStart: function () {
      triggerEvent(this.el, this.options.zoomStartEventName);
      this.stopAnimation();
      this.lastScale = 1;
      this.nthZoom = 0;
      this.lastZoomCenter = false;
      this.hasInteraction = true;
    },

    /**
     * Event handler for 'zoom'
     * @param event
     */
    handleZoom: function (event, newScale) {
      // a relative scale factor is used
      var touchCenter = this.getTouchCenter(this.getTouches(event)),
        scale = newScale / this.lastScale;
      this.lastScale = newScale;

      // the first touch events are thrown away since they are not precise
      this.nthZoom += 1;
      if (this.nthZoom > 3) {

        this.scale(scale, touchCenter);
        this.drag(touchCenter, this.lastZoomCenter);
      }
      this.lastZoomCenter = touchCenter;
    },

    handleZoomEnd: function () {
      triggerEvent(this.el, this.options.zoomEndEventName);
      const closeToOne = isCloseTo(this.zoomFactor, 1);
      store.dispatch(setCanvasScale(closeToOne ? 1 : this.zoomFactor));
      this.end();
    },

    /**
     * Event handler for 'doubletap'
     * @param event
     */
    handleDoubleTap: function (event) {
      // document.querySelector('.canvas-text').innerHTML = 'doubleTap' + JSON.stringify(event);
      var center = this.getTouches(event)[0],
        zoomFactor = this.zoomFactor > 1 ? 1 : this.options.tapZoomFactor,
        startZoomFactor = this.zoomFactor,
        updateProgress = (function (progress) {
          this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
        }).bind(this);

      if (this.hasInteraction) {
        return;
      }
      if (startZoomFactor > zoomFactor) {
        center = this.getCurrentZoomCenter();
      }

      this.animate(this.options.animationDuration, updateProgress, this.swing);
      triggerEvent(this.el, this.options.doubleTapEventName);
    },

    /**
     * Zoom on canvas click
     * @param center {object}
     * @param zoomFactor {number}
     * @param allowMoving {boolean} // only for nav = product for similar products
     * @param withFeatureScreen {boolean} // determines whether we display feature selections with feature screen or only feature selections
     */
    zoomToCenter: function (center, zoomFactor, allowMoving = false, withFeatureScreen = true) {
      // this.elText.innerHTML = 'zoomToCenter' + this.isZooming;
      // var center = this.getTouches(event)[0],

      // window.clearTimeout(this.mouseDownTimeoutId);

      const zoomOut = !center && zoomFactor === 1;
      const zoomOutFromLeft = zoomOut && this.offset.x < 0;

      if (!zoomFactor) {
        zoomFactor = this.zoomFactor > 1 ? this.zoomFactor : this.options.tapZoomFactor;
      }

      if (!center) {
        center = {
          x: this.el.clientWidth / 2,
          y: this.el.clientHeight / 2,
        }
      }

      // console.log("this.zoomFactor", this.zoomFactor);
      // console.log("zoomFactor", zoomFactor);

      // const alreadyZoomed = (this.zoomFactor > 1) && (zoomFactor > 1) && (zoomFactor !== this.options.maxZoom);
      // const alreadyZoomed = false; // here is always false, because we removed moving canvas in zoomed mode
      const alreadyZoomed = IS_PRODUCT_JOURNEY && allowMoving && (this.zoomFactor === this.options.maxZoom) // allow moving canvas in zoomed mode for new navigation type
      const startZoomFactor = this.zoomFactor;
      const startOffset = {
        x: this.zoomFactor === 1 ? 0 : this.offset.x,
        y: this.zoomFactor === 1 ? 0 : this.offset.y
      };
      const targetOffset = {
        x: sanitizeValue((zoomFactor - 1) * center.x),
        y: sanitizeValue((zoomFactor - 1) * center.y)
      };
      // console.log("this.offset", this.offset);
      // console.log("targetOffset", targetOffset);

      if (this.hasInteraction) {
        return;
      }
      if (startZoomFactor > zoomFactor) {
        center = this.getCurrentZoomCenter();
      }

      if (alreadyZoomed) { // keep it as is, old support, not sure how it works if we delete it

        const updateProgress = alreadyZoomed
          ? (function (progress) {
            this.offset.x = sanitizeValue(startOffset.x + progress * (targetOffset.x - startOffset.x));
            this.offset.y = sanitizeValue(startOffset.y + progress * (targetOffset.y - startOffset.y));
            this.update();
          }).bind(this)
          : (function (progress) {
            // console.log("startZoomFactor + progress * (zoomFactor - startZoomFactor)", startZoomFactor + progress * (zoomFactor - startZoomFactor));
            this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center, false);
          }).bind(this);

        this.animate(this.options.animationDuration, updateProgress, this.swing, () => {
          triggerEvent(this.el, this.options.zoomEndEventName);
          // console.log("finished", );
          if (zoomOutFromLeft) {
            this.moveContainer(center, zoomFactor);
          }
          this.stopAnimation();
          this.end();
          // if (this.isInsaneOffset(this.offset)) {
          //   this.sanitizeOffsetAnimation();
          // }
          this.offset = targetOffset;
          // window.clearTimeout(this.mouseDownTimeoutId);
          // console.log("end zoom", );
        });
      } else {
        // console.log("targetOffset.x", targetOffset.x);
        // if (targetOffset.x > 500) { // magic number to zoom in correct position
        //   targetOffset.x = targetOffset.x * 1.8 // magic number to zoom in correct position
        // }
        this.update(targetOffset); // set canvas transform
        if (zoomOutFromLeft) {
          this.moveContainer(center, zoomFactor);
        }
        this.scaleTo(zoomFactor, center, false);
        this.offset = this.sanitizeOffset(targetOffset);
        this.stopAnimation();
        this.hasInteraction = false;
        this.offset = this.sanitizeOffset(targetOffset);
        this.end();
        triggerEvent(this.el, this.options.zoomEndEventName);
      }

      if (!zoomOutFromLeft) {
        this.moveContainer(center, zoomFactor, withFeatureScreen);
      }
    },

    /**
     * removes container and blurres from the co image
     * @param withAnimation {boolean}
     */
    removeContainerScroll: function (withAnimation = false) {
      // if (this.coImage) {
      //   this.coImage.classList.remove("blurred");
      // }
      this.setContainerTransform(null, withAnimation);
      this.containerScrolled = false;

      // if (withAnimation) {
      //   this.setContainerTransform(null, withAnimation);
      //   this.containerScrolled = false;
      // } else {
      //   const center = this.getCurrentZoomCenter();
      //   const updateProgress = (function (progress) {
      //     this.scaleTo(this.zoomFactor + progress * (1 - this.zoomFactor), center, false);
      //   }).bind(this);
      //   this.animate(this.options.animationDuration, updateProgress, this.swing, () => {
      //     triggerEvent(this.el, this.options.zoomEndEventName);
      //     this.offset = {x: 0, y: 0};
      //     this.containerScrolled = false;
      //   });
      // }

    },

    /**
     * moves container and blurres the co image
     * @param center
     * @param zoomFactor
     * @param withFeatureScreen {boolean}
     */
    moveContainer: function (center, zoomFactor, withFeatureScreen) {
      // console.log("moveContainer center", center, zoomFactor);
      if (zoomFactor === 1 && this.containerScrolled) {
        this.removeContainerScroll();
        return
      }
      if (IS_PRODUCT_JOURNEY) {
        this.moveGroheContainer(center, zoomFactor, withFeatureScreen);
        return;
      }
      if (center && center.featureX) {
        if (center.isMobile) {
          // const menuWidth = 316;
          // const shiftX = center.clientWidth - (center.clientWidth * center.featureX / 100);
          // // console.log("shiftX", shiftX);
          // if (shiftX < menuWidth) {
          // // if (center.x === center.clientWidth) {
          //   this.setContainerTransform('translateX(-'+menuWidth+'px)');
          //   this.containerScrolled = true;
          // }
        } else if (!center.x) {
          const offsetX = center.x === 0 ? 420 : 0;
          const percentX = center.clientWidth * center.featureX / 100;
          const shiftX = percentX > 420 ? 0 : 420 - percentX;
          const offsetY = 0;
          const transform2d =   'translate('   + (offsetX + shiftX)   + 'px,' + offsetY    + 'px)';
          this.setContainerTransform(transform2d);
          this.containerScrolled = true;
        // } else {
        //   this.removeContainerScroll();
        }
      } else if (center && !center.isMobile && center.x && this.containerScrolled) {
        this.removeContainerScroll();
      }
    },

    /**
     * moves container and blurres the co image (for nav type = grohe)
     * @param center
     * @param zoomFactor
     * @param withFeatureScreen {boolean}
     */
    moveGroheContainer: function (center, zoomFactor, withFeatureScreen) {
      if (center && center.featureX) {
        const state = store.getState();
        let menuWidth = center.isMobile ? GROHE_CONFIG.sidebarWidth.mobile : GROHE_CONFIG.mainBarWidth.desktop;
        if ((state.groheState.similarProductsOpened || state.lookState.lookActiveCategory) && !center.isMobile) {
          menuWidth = withFeatureScreen ? menuWidth + GROHE_CONFIG.similarProductsWidth.desktop : GROHE_CONFIG.similarProductsWidth.desktop
        }
        // console.log("shiftX", shiftX);
        // console.log("center.featureX", center.featureX);
        if (center.featureX > 20 && (window.innerWidth <= 1920)) { // no need to move container on full hd monitors
          // if feature X is less than 20 - it is ok not to scroll anywhere
          let translate = 0;
          if (center.featureX > 80) {
            translate = menuWidth // for the very right positions
          } else {
            translate = center.featureX * 3.4 // magic number for moving container
            if (center.featureX > 70) {
              translate = translate + 20; // plus 20 pixels
            } else if (center.featureX > 60) {
              translate = translate + 50; // plus 50 pixels if more than 60
            } else if (center.featureX > 50) {
              translate = translate + 80; // plus 80 pixels if between 50 and 70
            }
            if (translate > menuWidth) {
              translate = menuWidth; // just in case we are overscrolling
            }
          }
          this.setContainerTransform('translateX(-' + translate + 'px)', true);
          this.containerScrolled = true;
        } else if (this.containerScrolled) {
          // this.removeContainerScroll(true);
        }
      } else if (center && !center.isMobile && center.x && this.containerScrolled) {
        this.removeContainerScroll(true);
      }
    },

    /**
     * sets container transform position
     * @param transform2d
     * @param withAnimation {boolean}
     */
    setContainerTransform: function (transform2d, withAnimation = false) {
      // this.elText.innerHTML = 'setContainerTransform' + withAnimation;

      if (transform2d) {
        // if (this.coImage && !this.coImage.classList.contains("blurred")) {
        //   this.coImage.classList.add("blurred");
        // }
        if (!this.containerScrolled) {
          this.containerScrolled = true;
        }
      }
      clearTimeout(this.containerTransition);
      if (withAnimation) {
        this.container.style.transition = "all 0.5s ease";
      }
      this.container.style.webkitTransform = transform2d;
      this.container.style.mozTransform = transform2d;
      this.container.style.msTransform = transform2d;
      this.container.style.oTransform = transform2d;
      this.container.style.transform = transform2d;
      if (withAnimation) {
        this.containerTransition = setTimeout(() => {
          this.container.style.transition = "none";
        }, 500)
      }
    },

    /**
     * Max / min values for the offset
     * @param offset
     * @return {Object} the sanitized offset
     */
    sanitizeOffset: function (offset) {
      var maxX = (this.zoomFactor - 1) * this.getContainerX(),
        maxY = (this.zoomFactor - 1) * this.getContainerY(),
        maxOffsetX = Math.max(maxX, 0),
        maxOffsetY = Math.max(maxY, 0),
        minOffsetX = Math.min(maxX, 0),
        minOffsetY = Math.min(maxY, 0);

      return {
        x: sanitizeValue(Math.min(Math.max(offset.x, minOffsetX), maxOffsetX)),
        y: sanitizeValue(Math.min(Math.max(offset.y, minOffsetY), maxOffsetY))
      };
    },

    /**
     * Scale to a specific zoom factor (not relative)
     * @param zoomFactor
     * @param needToMoveContainer {boolean}
     * @param center
     */
    scaleTo: function (zoomFactor, center, needToMoveContainer = true) {
      this.scale(zoomFactor / this.zoomFactor, center);
      if (needToMoveContainer && zoomFactor === 1) {
        this.moveContainer(null, zoomFactor);
      }
    },

    /**
     * Scales the element from specified center
     * @param scale
     * @param center
     */
    scale: function (scale, center) {
      scale = this.scaleZoomFactor(scale);
      this.addOffset({
        x: sanitizeValue((scale - 1) * (center.x + this.offset.x)),
        y: sanitizeValue((scale - 1) * (center.y + this.offset.y))
      });
    },

    /**
     * Scales the zoom factor relative to current state
     * @param scale
     * @return the actual scale (can differ because of max min zoom factor)
     */
    scaleZoomFactor: function (scale) {
      var originalZoomFactor = this.zoomFactor;
      this.zoomFactor *= scale;
      this.zoomFactor = Math.round(Math.min(this.options.maxZoom, Math.max(this.zoomFactor, this.options.minZoom)) * 1000) / 1000;
      return this.zoomFactor / originalZoomFactor;
    },

    /**
     * Drags the element
     * @param center
     * @param lastCenter
     */
    drag: function (center, lastCenter) {
      if (lastCenter) {
        if(this.options.lockDragAxis) {
          // lock scroll to position that was changed the most
          if(Math.abs(center.x - lastCenter.x) > Math.abs(center.y - lastCenter.y)) {
            this.addOffset({
              x: -(center.x - lastCenter.x),
              y: 0
            });
          }
          else {
            this.addOffset({
              y: -(center.y - lastCenter.y),
              x: 0
            });
          }
        }
        else {
          this.addOffset({
            y: -(center.y - lastCenter.y),
            x: -(center.x - lastCenter.x)
          });
        }
      }
    },

    /**
     * Calculates the touch center of multiple touches
     * @param touches
     * @return {Object}
     */
    getTouchCenter: function (touches) {
      return this.getVectorAvg(touches);
    },

    /**
     * Calculates the average of multiple vectors (x, y values)
     */
    getVectorAvg: function (vectors) {
      return {
        x: vectors.map(function (v) { return v.x; }).reduce(sum) / vectors.length,
        y: vectors.map(function (v) { return v.y; }).reduce(sum) / vectors.length
      };
    },

    /**
     * Adds an offset
     * @param offset the offset to add
     * @return return true when the offset change was accepted
     */
    addOffset: function (offset) {
      this.offset = {
        x: sanitizeValue(this.offset.x + offset.x),
        y: sanitizeValue(this.offset.y + offset.y)
      };
    },

    sanitize: function () {
      if (this.zoomFactor < this.options.zoomOutFactor) {
        this.zoomOutAnimation();
      } else if (this.isInsaneOffset(this.offset)) {
        this.sanitizeOffsetAnimation();
      }
    },

    /**
     * Checks if the offset is ok with the current zoom factor
     * @param offset
     * @return {Boolean}
     */
    isInsaneOffset: function (offset) {
      var sanitizedOffset = this.sanitizeOffset(offset);
      return sanitizedOffset.x !== offset.x ||
        sanitizedOffset.y !== offset.y;
    },

    /**
     * Creates an animation moving to a sane offset
     */
    sanitizeOffsetAnimation: function () {
      var targetOffset = this.sanitizeOffset(this.offset),
        startOffset = {
          x: this.offset.x,
          y: this.offset.y
        },
        updateProgress = (function (progress) {
          this.offset.x = sanitizeValue(startOffset.x + progress * (targetOffset.x - startOffset.x));
          this.offset.y = sanitizeValue(startOffset.y + progress * (targetOffset.y - startOffset.y));
          this.update();
        }).bind(this);

      this.animate(
        this.options.animationDuration,
        updateProgress,
        this.swing
      );
    },

    /**
     * Zooms back to the original position,
     * (no offset and zoom factor 1)
     */
    zoomOutAnimation: function () {
      var startZoomFactor = this.zoomFactor,
        zoomFactor = 1,
        center = this.getCurrentZoomCenter(),
        updateProgress = (function (progress) {
          this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
        }).bind(this);

      this.animate(
        this.options.animationDuration,
        updateProgress,
        this.swing
      );
    },

    /**
     * Updates the aspect ratio
     */
    updateAspectRatio: function () {
      this.setContainerY(this.getContainerX() / this.getAspectRatio());
    },

    /**
     * Calculates the initial zoom factor (for the element to fit into the container)
     * @return the initial zoom factor
     */
    getInitialZoomFactor: function () {
      return this.container.offsetWidth / this.el.offsetWidth;
    },

    /**
     * Calculates the aspect ratio of the element
     * @return the aspect ratio
     */
    getAspectRatio: function () {
      return this.el.offsetWidth / this.el.offsetHeight;
    },

    /**
     * Calculates the virtual zoom center for the current offset and zoom factor
     * (used for reverse zoom)
     * @return {Object} the current zoom center
     */
    getCurrentZoomCenter: function () {

      // uses following formula to calculate the zoom center x value
      // offset_left / offset_right = zoomcenter_x / (container_x - zoomcenter_x)
      var length = this.container.offsetWidth * this.zoomFactor,
        offsetLeft  = this.offset.x,
        offsetRight = length - offsetLeft - this.container.offsetWidth,
        widthOffsetRatio = offsetLeft / offsetRight,
        centerX = widthOffsetRatio * this.container.offsetWidth / (widthOffsetRatio + 1),

        // the same for the zoomcenter y
        height = this.container.offsetHeight * this.zoomFactor,
        offsetTop  = this.offset.y,
        offsetBottom = height - offsetTop - this.container.offsetHeight,
        heightOffsetRatio = offsetTop / offsetBottom,
        centerY = heightOffsetRatio * this.container.offsetHeight / (heightOffsetRatio + 1);

      // prevents division by zero
      if (offsetRight === 0) { centerX = this.container.offsetWidth; }
      if (offsetBottom === 0) { centerY = this.container.offsetHeight; }

      return {
        x: centerX,
        y: centerY
      };
    },

    canDrag: function () {
      return !isCloseTo(this.zoomFactor, 1);
    },

    /**
     * Returns the touches of an event relative to the container offset
     * @param event
     * @return array touches
     */
    getTouches: function (event) {
      var rect = this.container.getBoundingClientRect();
      var posTop = rect.top + document.body.scrollTop;
      var posLeft = rect.left + document.body.scrollLeft;

      return Array.prototype.slice.call(event.touches).map(function (touch) {
        return {
          x: touch.pageX - posLeft,
          y: touch.pageY - posTop,
        };
      });
    },
    //
    // /**
    //  * Returns the touches of an event relative to the container offset
    //  * @param event
    //  * @return array touches
    //  */
    // getMousePosition: function (event, container) {
    //   var rect = container.getBoundingClientRect();
    //   var posTop = rect.top + document.body.scrollTop;
    //   var posLeft = rect.left + document.body.scrollLeft;
    //
    //   return {
    //     x: event.pageX - posLeft,
    //     y: event.pageY - posTop,
    //   };
    // },

    /**
     * Animation loop
     * does not support simultaneous animations
     * @param duration
     * @param framefn
     * @param timefn
     * @param callback
     */
    animate: function (duration, framefn, timefn, callback) {

      let start = performance.now();
      this.inAnimation = true;
      const _self = this;

      requestAnimationFrame(function animateNew(time) {
        // timeFraction изменяется от 0 до 1
        if (!_self.inAnimation) { return; }
        let timeFraction = (time - start) / duration;
        if (timeFraction > 1) timeFraction = 1;

        // вычисление текущего состояния анимации
        let progress = timeFraction;

        framefn(progress); // отрисовать её
        _self.update();

        if (timeFraction < 1) {
          requestAnimationFrame(animateNew);
        } else {
          framefn(1);
          if (callback) {
            callback();
          }
          _self.update();
          _self.stopAnimation();
          _self.update();
        }
      });

      // var startTime = new Date().getTime(),
      //   renderFrame = (function () {
      //     if (!this.inAnimation) { return; }
      //     var frameTime = new Date().getTime() - startTime,
      //       progress = frameTime / duration;
      //     if (frameTime >= duration) {
      //       framefn(1);
      //       if (callback) {
      //         callback();
      //       }
      //       this.update();
      //       this.stopAnimation();
      //       this.update();
      //     } else {
      //       if (timefn) {
      //         progress = timefn(progress);
      //       }
      //       framefn(progress);
      //       this.update();
      //       requestAnimationFrame(renderFrame);
      //     }
      //   }).bind(this);
      // this.inAnimation = true;
      // requestAnimationFrame(renderFrame);
    },

    /**
     * Stops the animation
     */
    stopAnimation: function () {
      this.inAnimation = false;
    },

    /**
     * Swing timing function for animations
     * @param p
     * @return {Number}
     */
    swing: function (p) {
      return -Math.cos(p * Math.PI) / 2  + 0.5;
    },

    getContainerX: function () {
      return this.container.offsetWidth;
    },

    getContainerY: function () {
      return this.container.offsetHeight;
    },

    setContainerY: function (y) {
      return this.container.style.height = y + 'px';
    },

    /**
     * Creates the expected html structure
     */
    setupMarkup: function () {
      this.container = buildElement('<div class="pinch-zoom-container"></div>');
      this.coImage = document.getElementsByClassName("canvas-co-image")[0];
      this.el.parentNode.insertBefore(this.container, this.el);
      this.container.appendChild(this.el);

      this.container.style.overflow = 'hidden';
      this.container.style.position = 'relative';

      this.el.style.webkitTransformOrigin = '0% 0%';
      this.el.style.mozTransformOrigin = '0% 0%';
      this.el.style.msTransformOrigin = '0% 0%';
      this.el.style.oTransformOrigin = '0% 0%';
      this.el.style.transformOrigin = '0% 0%';

      // this.el.style.position = 'absolute';
    },

    end: function () {
      this.hasInteraction = false;
      this.sanitize();
      // document.querySelector('.canvas-text').innerHTML = 'update end';
      this.update();
    },

    /**
     * Binds all required event listeners
     */
    bindEvents: function () {
      var self = this;
      detectGestures(this.container, this, this.elText);

      window.addEventListener('resize', this.updateCheck.bind(this));
      Array.from(this.el.querySelectorAll('img')).forEach(function(imgEl) {
        imgEl.addEventListener('load', self.update.bind(self));
      });

      if (this.el.nodeName === 'IMG') {
        this.el.addEventListener('load', this.update.bind(this));
      }
    },

    updateCheck: function () {
      if (!(window.canvasIsDragging || window.mobileMenuOpened)) {
        // document.querySelector('.canvas-text').innerHTML = 'update resize';
        this.update();
      }
    },

    getCanvasTransform: function (targetOffset = this.offset, targetZoomFactor = this.zoomFactor, useNewScale = false) {
      // if (useNewScale) {
      //   debugger;//eslint-disable-line
      // }
      var zoomFactor = this.getInitialZoomFactor() * targetZoomFactor,
        offsetX = -targetOffset.x / zoomFactor,
        offsetY = -targetOffset.y / zoomFactor;
      if (useNewScale) {
        offsetX = offsetX * 1.8 // magic number to zoom in correct position
      }
      var transform3d = useNewScale
          ? 'translate3d(' + (offsetX > 0 ? 0 : offsetX) + 'px,' + offsetY + 'px,0px)' + ' scale3d(' + zoomFactor + ', ' + zoomFactor + ',1)'
          : 'scale3d(' + zoomFactor + ', ' + zoomFactor + ',1)' + 'translate3d(' + (offsetX > 0 ? 0 : offsetX) + 'px,' + offsetY + 'px,0px)',
        transform2d = useNewScale
          ? 'translate(' + (offsetX > 0 ? 0 : offsetX) + 'px,' + offsetY + 'px)' + ' scale(' + zoomFactor + ', ' + zoomFactor + ')'
          : 'scale(' + zoomFactor + ', '  + zoomFactor + ') ' + 'translate('   + (offsetX > 0 ? 0 : offsetX) + 'px,' + offsetY    + 'px)';

      return {zoomFactor, offsetX, offsetY, transform2d, transform3d}
    },

    setCanvasTransform: function (transform2d, transform3d = "") {
      this.el.style.webkitTransform = transform3d || transform2d;
      this.el.style.mozTransform = transform2d;
      this.el.style.msTransform = transform2d;
      this.el.style.oTransform = transform2d;
      this.el.style.transform = transform3d || transform2d;
    },

    /**
     * Updates the css values according to the current zoom factor and offset
     */
    update: function (targetOffset = this.offset) {
      if (this.updatePlaned || window.canvasIsDragging) {
        return;
      }
      this.updatePlaned = true;

      // document.querySelector('.canvas-text').innerHTML = 'ahahah update';
      // document.querySelector('.canvas-text').innerHTML = this.enabled;

      window.setTimeout((function () {
        this.updatePlaned = false;
        this.updateAspectRatio();

        // this.elText.innerHTML = this.offset.x + " / " + this.offset.y;
        const isMobile = this.el.dataset.mobile === "true";

        var {offsetX, transform2d, transform3d}
          = this.getCanvasTransform(targetOffset, this.zoomFactor, true); // new for desktop

        var removeClone = (function () {
          if (this.clone) {
            this.clone.parentNode.removeChild(this.clone);
            delete this.clone;
          }
        }).bind(this);

        const offsetXForContainer = offsetX / 1.8; // because we increased it in getCanvasTransform func
        if (offsetXForContainer > 0 && !interaction && !IS_PRODUCT_JOURNEY) {
          const shiftXFromLeft = isMobile ? 2 : 2.5;
          let translateX = offsetXForContainer > 10 ? offsetXForContainer * shiftXFromLeft : offsetXForContainer;
          if (IS_LOOK_JOURNEY && isMobile && translateX > 320) {
            translateX = 320; // kvScene range fix
          }
          this.setContainerTransform('translateX('+(translateX)+'px)');
        }

        // Scale 3d and translate3d are faster (at least on ios)
        // but they also reduce the quality.
        // PinchZoom uses the 3d transformations during interactions
        // after interactions it falls back to 2d transformations
        if (!this.options.use2d || this.hasInteraction || this.inAnimation) {
          this.is3d = true;
          removeClone();
          this.setCanvasTransform(transform2d, transform3d);
        } else {
          // When changing from 3d to 2d transform webkit has some glitches.
          // To avoid this, a copy of the 3d transformed element is displayed in the
          // foreground while the element is converted from 3d to 2d transform
          if (this.is3d) {
            this.clone = this.el.cloneNode(true);
            this.clone.style.pointerEvents = 'none';
            this.container.appendChild(this.clone);
            window.setTimeout(removeClone, 200);
          }

          this.setCanvasTransform(transform2d);

          this.is3d = false;
        }
      }).bind(this), 0);
    },

    /**
     * Enables event handling for gestures
     */
    enable: function() {
      this.enabled = true;
    },

    /**
     * Disables event handling for gestures
     */
    disable: function() {
      this.enabled = false;
    },

    /**
     * Returns scale
     */
    getScale: function() {
      return this.zoomFactor
    },

    reset: function() {
      // var currentTranslate = getTranslate(this.el);
      // this.elText.innerHTML = JSON.stringify(currentTranslate);
      this.zoomFactor = 1;
      this.offset = {
        x: 0,
        y: 0
      };
      // this.end();
      // this.elText.innerHTML = 'reset!';

    },

    imageCanvasScroll: function (canvasClass, removeAllClasses, layoutType) {

      // document.querySelector('.canvas-text').innerHTML = 'imageCanvasScroll ' + canvasClass;
      clearTimeout(this.timerId);
      if (removeAllClasses) {
        window.imageCanvasScroll = true;
        this.el.style.transition = 'all 0.5s ease';
        this.el.style.WebkitTransition = 'all 0.5s ease';
        this.el.style.MozTransition = 'all 0.5s ease';
        this.timerId = setTimeout(() => {
          if (this.el.style.transition === 'all 0.5s ease') {
            this.el.style.transition = 'none';
            this.el.style.WebkitTransition = 'none';
            this.el.style.MozTransition = 'none';
          }
          window.imageCanvasScroll = false;
        }, 500);
      } else {
        window.imageCanvasScroll2 = true;
        this.el.style.transition = 'all 1.3s cubic-bezier(0.4, 0.01, 0.51, 1)';
        this.el.style.WebkitTransition = 'all 1.3s cubic-bezier(0.4, 0.01, 0.51, 1)';
        this.el.style.MozTransition = 'all 1.3s cubic-bezier(0.4, 0.01, 0.51, 1)';
        this.timerId = setTimeout(() => {
          if (this.el.style.transition === 'all 1.3s cubic-bezier(0.4, 0.01, 0.51, 1)') {
            this.el.style.transition = 'none';
            this.el.style.WebkitTransition = 'none';
            this.el.style.MozTransition = 'none';
          }
          window.imageCanvasScroll2 = false;
        }, 1300);
      }

      const
        zoomFactor = 1,
        offsetX = pinchScroll(canvasClass, this.getContainerX(), layoutType),
        offsetY = '0';

      const transform2d =   'scale('       + zoomFactor + ', '  + zoomFactor + ') ' +
        'translate('   + offsetX    + ',' + offsetY    + 'px)';
      this.setCanvasTransform(transform2d);
    },

    onMouseDown: function (event) {
      // console.log("mousedown", );
      if (this.zoomFactor > 1) {
        this.firstMove = true; // was true
        this.mouseDown = [event.pageX, event.pageY];
        // this.elText.innerHTML = 'mousedown' + this.mousePos[0] + "";
        window.touchMove = false;
      }
    },
    onMouseMove: function (event) {
      if (this.mouseDown) {
        if (this.firstMove) {
          this.handleDragStart(event, false);
          triggerEvent(window, ActionTypes.REMOVE_GREEN_ZONE_ON_CANVAS);
          window.touchMove = true;
          this.el.classList.add("drag");
          event.stopPropagation();
          event.preventDefault();
        } else {
          this.handleMove(event);
          this.update();
        }
        this.firstMove = false;
      }
    },
    onMouseUp: function (event, lookCanvasClick) {
      // console.log("mouseup", );

      if (this.mouseDown) {
        const diffX = Math.abs(event.pageX - this.mouseDown[0]);
        const diffY = Math.abs(event.pageY - this.mouseDown[1]);

        this.mouseDown = null;
        window.touchMove = false;
        this.el.classList.remove("drag");
        if (this.hasInteraction) {
          this.hasInteraction = false
        }

        if (diffX < this.options.dragPixelsBeforeClick && diffY < this.options.dragPixelsBeforeClick) {
          lookCanvasClick(event); // Click! we moved less than 6 pixels
        } else {
          // console.log("this.handleDragEnd :(");
          // window.clearTimeout(this.mouseDownTimeoutId);
          this.handleDragEnd();
        }
      } else if (lookCanvasClick) {
        lookCanvasClick(event)
      }
    },

  };

  var detectGestures = function (el, target) {
    let fingers = 0,
      // lastTouchStart = null,
      startTouches = null,

      setInteraction = function (newInteraction, event) {
        if (interaction !== newInteraction) {

          if (interaction && !newInteraction) {
            switch (interaction) {
              case "zoom":
                target.handleZoomEnd(event);
                break;
              case 'drag':
                target.handleDragEnd(event);
                break;
            }
          }

          switch (newInteraction) {
            case 'zoom':
              target.handleZoomStart(event);
              break;
            case 'drag':
              target.handleDragStart(event);
              break;
          }
        }
        interaction = newInteraction;
      },

      updateInteraction = function (event) {
        if (fingers === 2) {
          setInteraction('zoom');
        } else if (fingers === 1 && target.canDrag()) {
          setInteraction('drag', event);
        } else {
          setInteraction(null, event);
        }
      },

      targetTouches = function (touches) {
        return Array.from(touches).map(function (touch) {
          return {
            x: touch.pageX,
            y: touch.pageY
          };
        });
      },

      getDistance = function (a, b) {
        var x, y;
        x = a.x - b.x;
        y = a.y - b.y;
        return Math.sqrt(x * x + y * y);
      },

      calculateScale = function (startTouches, endTouches) {
        var startDistance = getDistance(startTouches[0], startTouches[1]),
          endDistance = getDistance(endTouches[0], endTouches[1]);
        return endDistance / startDistance;
      },

      cancelEvent = function (event) {
        event.stopPropagation();
        event.preventDefault();
      },

      // detectDoubleTap = function (event) {
      //   var time = (new Date()).getTime();
      //
      //   if (fingers > 1) {
      //     lastTouchStart = null;
      //   }
      //
      //   if (time - lastTouchStart < 300) {
      //     cancelEvent(event);
      //
      //     target.handleDoubleTap(event);
      //     switch (interaction) {
      //       case "zoom":
      //         target.handleZoomEnd(event);
      //         break;
      //       case 'drag':
      //         target.handleDragEnd(event);
      //         break;
      //     }
      //   }
      //
      //   if (fingers === 1) {
      //     lastTouchStart = time;
      //   }
      // },
      firstMove = true;

    el.addEventListener('touchstart', function (event) {
      try {
        // target.elText.innerHTML = 'touchstart';
        if(target.enabled) {
          firstMove = true;
          fingers = event.touches.length;
          // target.elText.innerHTML = 'touchstart 2 ' + fingers;

          // if (!window.mobileMenuOpened) {
          //   detectDoubleTap(event);
          // }
        }
        window.touchMove = false;
      } catch (e) {
        // alert(e)
      }

    });

    el.addEventListener('touchmove', function (event) {
      try {
        if(target.enabled) {
          if (firstMove) {
            updateInteraction(event);
            if (interaction) {
              cancelEvent(event);
            }
            startTouches = targetTouches(event.touches);
          } else {
            switch (interaction) {
              case 'zoom':
                target.handleZoom(event, calculateScale(startTouches, targetTouches(event.touches)));
                break;
              case 'drag':
                target.handleDrag(event);
                break;
            }
            if (interaction) {
              cancelEvent(event);
              target.update();
            }
          }

          firstMove = false;
        }
        // target.elText.innerHTML = 'touchmove';
        window.touchMove = true;
      } catch (e) {
        // alert(e)
        target.reset();
        target.zoomOutAnimation()
      }
    });

    el.addEventListener('touchend', function (event) {
      try {
        // target.elText.innerHTML = 'touchend';
        window.touchMove = false;
        target.stopAnimation();
        if (+isCloseTo(target.zoomFactor, 1) && interaction) {
          // target.elText.innerHTML = 'touchend 2' + target.zoomFactor;
          target.handleDragEnd();
          target.reset();
          target.zoomOutAnimation()
        }
        if (target.enabled) {
          // target.elText.innerHTML = 'touchend 1' + target.zoomFactor;
          fingers = event.touches.length;
          updateInteraction(event);
        }
      } catch (e) {
        // alert(e)
        target.reset();
        target.zoomOutAnimation()
      }
    });

  };

  return PinchZoom;
};

var PinchZoom = definePinchZoom();

export default PinchZoom;
